import { Component } from '@angular/core';

@Component({
  selector: 'app-photoalbums',
  templateUrl: './photoalbums.component.html',
  styleUrl: './photoalbums.component.scss'
})
export class PhotoalbumsComponent {

}
